import React from "react";
import { Button, Table } from "react-bootstrap";
import { Edit, Trash } from "react-feather";
import { formatDate } from "../config/function";

const WagonList = ({ wagonData, handleEdit, handleDelete }) => {
  return (
    <Table>
      <thead>
        <tr>
          <th>S.No</th>
          <th>Date</th>
          <th>Station</th>
          <th>Vehicle Count</th>
          <th>Advance</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {wagonData.map((data, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>{formatDate(data.date)}</td>
            <td style={{ textTransform: "capitalize" }}>{data.station}</td>
            <td>{data.vehicle_count}</td>
            <td>{data.advance}</td>
            <td>
              <div className="d-flex gap-2">
                <Button
                  variant="warning"
                  size="sm"
                  onClick={() => handleEdit(data)}
                >
                  <Edit size={14} />
                </Button>

                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDelete(data.id)}
                >
                  <Trash size={14} />
                </Button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default WagonList;
